import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// The window scroll offset survives route changes. Participants is much taller
// than Community, so a deep offset is clamped to the bottom of the next page.
const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        if ('scrollRestoration' in window.history) {
            window.history.scrollRestoration = 'manual';
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default ScrollToTop;
